import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LastSeenItem {
  id: string;
  date: Date;
}

type LastSeenStore = {
  lastScenes: LastSeenItem[];
  lastSeenProjectFolders: LastSeenItem[];
  addLastScene: (id: string) => void;
  addLastProjectFolder: (id: string) => void;
};

export const store = create<LastSeenStore>()(
  persist(
    (set, get) => ({
      lastScenes: [],
      lastSeenProjectFolders: [],
      addLastScene: (id) => {
        const updatedScenes = [...get().lastScenes];
        const existingSceneIndex = updatedScenes.findIndex(
          (scene) => scene.id === id,
        );

        if (existingSceneIndex !== -1) {
          updatedScenes.splice(existingSceneIndex, 1);
        } else if (updatedScenes.length >= 10) {
          updatedScenes.shift();
        }

        updatedScenes.push({ id, date: new Date() });
        set({ lastScenes: updatedScenes });
      },
      addLastProjectFolder: (id) => {
        const updatedProjectFolders = [...get().lastSeenProjectFolders];
        const existingIndex = updatedProjectFolders.findIndex(
          (folder) => folder.id === id,
        );

        if (existingIndex !== -1) {
          updatedProjectFolders.splice(existingIndex, 1);
        } else if (updatedProjectFolders.length >= 10) {
          updatedProjectFolders.shift();
        }

        updatedProjectFolders.push({ id, date: new Date() });
        set({ lastSeenProjectFolders: updatedProjectFolders });
      },
    }),
    { name: 'last-viewed-scenes' },
  ),
);

export const useLastSeenStore = createSelectorHooks(store);
